<template>
  <b-modal
    @close="onClose"
    :active.sync="opened"
    :full-screen="isFullScreen"
    width="500px"
  >
    <div class="card">
      <div class="card-content tw-p-6">
        <validation-observer
          @submit.prevent="post"
          ref="notice"
          tag="form"
          v-slot="{ valid }"
        >
          <div class="columns">
            <div class="column is-narrow tw-pr-0">
              <figure>
                <p class="image is-48x48">
                  <img class="is-elongated" :src="user.avatar_thumb_url" />
                </p>
              </figure>
            </div>
            <div class="column">
              <validation-provider
                vid="notice"
                rules="required|min:50|max:1500"
                name="notice"
                v-slot="{ errors }"
              >
                <b-field
                  :message="errors"
                  :type="{ 'is-danger': errors.length }"
                  class="is-marginless"
                >
                  <b-input
                    rows="10"
                    v-model="form.notice"
                    placeholder="Write something..."
                    type="textarea"
                  >
                  </b-input>
                </b-field>
              </validation-provider>
            </div>
          </div>

          <div class="level">
            <div class="level-left"></div>
            <div class="level-right">
              <b-button
                :disabled="!valid || submitting"
                :loading="submitting"
                native-type="submit"
                type="is-primary"
              >
                Post notice
              </b-button>
            </div>
          </div>
        </validation-observer>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import Notice from '@/models/Notice'
import ModalMixin from '@/utils/mixins/modal'

export default {
  mixins: [ModalMixin],
  data() {
    return {
      opened: false,
      submitting: false,
      form: {
        notice: ''
      }
    }
  },
  computed: {
    ...mapState({
      group: state => state.group.currentGroup,
      user: state => state.auth.user
    })
  },
  methods: {
    open() {
      this.form = {
        notice: ''
      }
      this.opened = true
    },
    onClose() {},
    post() {
      this.submitting = true
      const notice = new Notice(this.form).for(this.group)
      notice
        .save()
        .then(response => {
          this.opened = false
          this.$emit('posted')
        })
        .catch(({ response }) => {
          if (response.data && response.data.errors) {
            this.$refs.notice.setErrors(response.data.errors)
          }
        })
        .then(() => {
          this.submitting = false
        })
    }
  }
}
</script>
